import get from 'lodash/get';
import invoke from 'lodash/invoke';
import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import React from 'react';
import Schema from '../../Schema/Schema';
import { host } from '../../../config/urlConfig';

const MovieSchema = (props: {
	path: any;
	movie: any;
	langKey: any;
	descKey: any;
	genreKey: any;
	imageKey: any;
	titleKey: any;
	relDateKey: any;
	durationKey: any;
	sentimentCountData: any;
}) => {
	const {
		path,
		movie,
		langKey,
		descKey,
		genreKey,
		imageKey,
		titleKey,
		relDateKey,
		durationKey,
		sentimentCountData,
	} = props;

	let schema: Record<string, any> = {
		'@context': 'http://schema.org',
		'@type': 'Movie',
		name: movie[titleKey],
		url: `${host}${path}`,
		genre: invoke(movie[genreKey], 'join', ', '),
		image: get(movie, 'imgPath') || movie[imageKey],
		inLanguage: movie[langKey],
		description: movie[descKey],
	};

	if (get(movie, durationKey)) {
		schema.duration = `PT${movie[durationKey]}M`;
	}

	const relDate = get(movie, relDateKey);
	if (relDate) {
		schema.datePublished = relDate;
		schema.releasedEvent = {
			'@context': 'http://schema.org',
			'@type': 'PublicationEvent',
			startDate: relDate,
			location: {
				'@type': 'Country',
				name: 'IN',
			},
		};
	}

	const movieTrailer = get(movie, 'trailer');
	if (movieTrailer) {
		schema.hasPart = {
			'@type': 'Clip',
			description: 'trailer',
			name: movie[titleKey],
			url: get(movie, 'trailer'),
		};
	}

	const ratingCount = get(sentimentCountData, 'totalVotes', 0);
	const likePercent = get(sentimentCountData, 'likePercent', 0);
	if (!isEmpty(sentimentCountData) && likePercent && ratingCount) {
		schema.aggregateRating = {
			'@context': 'http://schema.org',
			'@type': 'AggregateRating',
			ratingValue: likePercent / 10,
			bestRating: 10,
			ratingCount: ratingCount,
		};
	}

	schema = pickBy(schema);

	return <Schema schema={schema} />;
};

MovieSchema.defaultProps = {
	genreKey: 'genre',
	titleKey: 'label',
	descKey: 'descKey',
	langKey: 'lang',
	imageKey: 'bannerImageApp',
	durationKey: 'duration',
	relDateKey: 'releaseDate',
};

export default MovieSchema;
